import { useEffect } from 'react'

import * as con from "../../GlobalConstants"


import { GenericElement, MoneyElement } from "../../templates/FormElement"
import { RefApplicationParameterHook, StateApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { IsStaff } from '../hooks/AuthenticationHook'
import { Checkbox, FormGroup } from '@blueprintjs/core'
import { GenericCell, StaticSingleCell } from '../../templates/tables/Cells'
import {  addDays, afterADate, isStingValidForDate, isWeekEnd, parseDate } from '../../utils/dateFunctions'
import OptionAssessmentDownload from './OptionAssessmentDownload'
import LoadingIcon from '../../templates/loading/LoadingIcon'
import { RefNestedMarketValueHook, RefSPOT, useAssessmentRateData } from '../hooks/MarketValuesHook'

                          


function OptionAssessmentControls({assessmentSummary, assessedOptionDictionary}) {

    // Hidden columns
    const isStaff = IsStaff()
    const [showHiddenColumns, setShowHiddenColumns] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_HIDDEN_COLUMNS)


  return (        
      <div className='bigParameterBox'>
          <OptionAssessmentSummaryTable assessmentSummary={assessmentSummary} />
          <div>
            <OptionAssessmentRate />
            <OptionAssessmentFilter />
          </div>       
          <div>
            <h3>Comandos</h3>
            <div className="columnParameterBoxLeft">            
                <OptionAssessmentSelection/>
                {isStaff ? <Checkbox checked={showHiddenColumns} label="Columnas Ocultas" onChange={() => setShowHiddenColumns(!showHiddenColumns)}/>  : null }
            </div>
            <OptionAssessmentDownload assessmentSummary={assessmentSummary} assessedOptionDictionary={assessedOptionDictionary}/>
          </div>
      </div>
  )
}

export default OptionAssessmentControls


export const OptionAssessmentSummaryTable = ({assessmentSummary}) =>
{

    const showExpiredCoverages = RefApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_EXPIRED_COVERAGES)
    // Reference Date
    const [referenceDate, setReferenceDate] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_REFERENCE_DATE)
    const [startOptAssessmentDate, setStartOptAssessmentDate] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_START_DATE)

    // Loading
    const loading = RefApplicationParameterHook(con.LOADING_CURRENT_TRANSACTIONS)

    // Assessment Rate
    const rate = RefApplicationParameterHook(con.OPTION_ASSESSMENT_RATE)  

    if(loading){
      return (
        <div>
            <LoadingIcon/> 
        </div>
      )
    }

  return(
    <div>
      <h3>Resumen de Valoración de Derivados</h3>
      <div className="tightTable">
        <div className="tightColumn">
          {showExpiredCoverages && <StaticSingleCell content={"Fecha Inicio de Valoración"} isTitle={true}/>}
          <StaticSingleCell content={"Fecha de Valoración"} isTitle={true}/>
          <StaticSingleCell content={"Monto Opciones Activos"} isTitle={true}/>
          <StaticSingleCell content={"Tasa de Valoración"} isTitle={true}/>
          <StaticSingleCell content={"Valoración Portafolio"} isTitle={true}/>
          <StaticSingleCell content={"P&G de Prima"} isTitle={true}/>                       
          <StaticSingleCell content={"Valoración + Prima"} isTitle={true}/>                       

        </div>
        <div className="tightColumn">
          {showExpiredCoverages && 
          <GenericCell cellType={con.DATE} value={startOptAssessmentDate} setValue={(val) => isStingValidForDate(val) ? setStartOptAssessmentDate(parseDate(val)) : false} 
            editing={true} minDate={parseDate(con.MIN_ASSESSMENT_DATE)} shouldDisableDate={(d) => afterADate(d, addDays(referenceDate, -1)) || isWeekEnd(d)}/>}
          <GenericCell cellType={con.DATE} value={referenceDate} setValue={(val) => isStingValidForDate(val) ? setReferenceDate(parseDate(val)) : false} 
            editing={true} minDate={parseDate(con.MIN_ASSESSMENT_DATE)} 
            shouldDisableDate={(d) => {const date = new Date(d)
              const today = new Date()
              const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
              const isLastDayOfMonth = date.getDate() === lastDayOfMonth

              const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())
              const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate())
              const isAfterToday = dateOnly > todayOnly

              const todayLastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()
              const isTodayLastOfMonth = today.getDate() === todayLastDayOfMonth

              return !(isLastDayOfMonth && (!isAfterToday || isTodayLastOfMonth))
            }}/>
          <GenericCell evenRow={true} cellType={con.MONEY} value={assessmentSummary[con.ACTIVE_OPTION_AMOUNT]} currency={con.MONEY_USD} editing={false}/>
          <GenericCell evenRow={true} cellType={con.MONEY} allowDecimals={true} value={rate} currency={con.MONEY_COP} editing={false}/>
          <GenericCell evenRow={false} cellType={con.MONEY} value={assessmentSummary[con.PORTFOLIO_ASSESSMENT]} currency={con.MONEY_COP} editing={false}/>
          <GenericCell evenRow={true} cellType={con.MONEY} value={assessmentSummary[con.PREMIUM_GAINS]} currency={con.MONEY_COP} editing={false}/>
          <GenericCell evenRow={false} cellType={con.MONEY} value={assessmentSummary[con.TOTAL_ASSESSMENT]} currency={con.MONEY_COP} editing={false}/>
        </div>
    </div>
  </div>
  )
}

export const OptionAssessmentRate = () => {

  // Rate
  const [rate, setRate] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_RATE)
  const [origin, setOrigin] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_RATE_ORIGIN)
  const spot = RefSPOT()

  // Reference TRM and Close
  const { trm, trm1, close, isToday, isYesterday } = useAssessmentRateData(con.COVERAGES_OPTION)
  const trmReal = RefNestedMarketValueHook(con.TRMR_REAL, "trm_real")
  
  // Opciones del dropdown
  const rateOptionsLabels = ["Manual", "TRM", "TRM+1", "Cierre", "Spot"]
  const rateOptionsValues = [con.MANUAL, con.TRM, con.TRM_NEXT_DAY, con.CLOSE, con.SPOT]

  const filteredLabels = isToday ? rateOptionsLabels.filter((_, i) => rateOptionsValues[i] !== con.TRM_NEXT_DAY) : rateOptionsLabels
  const filteredValues = isToday ? rateOptionsValues.filter(v => v !== con.TRM_NEXT_DAY) : rateOptionsValues


  // Updates the rate
  useEffect(() => {
      if (origin === con.SPOT) {
          setRate(spot)
      } else if (origin === con.TRM) {
          setRate(isToday ? trmReal : trm)
      } else if (origin === con.TRM_NEXT_DAY) {
          setRate(isYesterday ? trmReal : trm1)
      } else if (origin === con.CLOSE) {
          setRate(close)
      }
  }, [origin, spot, trm, trm1, close, trmReal, isToday, isYesterday, setRate])


  return(
    <div className='columnParameterBox' style={{display:"flex", flexDirection:"row", gap : "50px"}}>
      <MoneyElement name="Tasa" value={rate} setValue={setRate} currency={con.MONEY_COP} disabled={origin !== con.MANUAL} allowDecimals={true}/>

      < GenericElement type={con.MULTIPLE_SELECTION}
                                name={'Esquema'}
                                // id={}               // Id not necessary
                                value={origin}
                                setValue={setOrigin}
                                values={filteredValues}
                                valueLabels={filteredLabels}
                                />
    </div>
  )

}

export const OptionAssessmentFilter = () => {

  const [includePurchases, setIncludePurchases] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_PURCHASES)
  const [includeSales, setIncludeSales] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_SALES)
  const [includeCalls, setIncludeCalls] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_CALL)
  const [includePuts, setIncludePuts] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_INCLUDE_PUT)

  return (
    <>
      <h2>Filtrar</h2>
      <FormGroup>
        <div className='bigParameterBox'>
          <Checkbox
            label="Compras"
            checked={includePurchases}
            onChange={() => setIncludePurchases(!includePurchases)}
          />
          <Checkbox
            label="Ventas"
            checked={includeSales}
            onChange={() => setIncludeSales(!includeSales)}
          />
        </div>

        <div className='bigParameterBox'>
          <Checkbox
            label="Calls"
            checked={includeCalls}
            onChange={() => setIncludeCalls(!includeCalls)}
          />
          <Checkbox
            label="Puts"
            checked={includePuts}
            onChange={() => setIncludePuts(!includePuts)}
          />
        </div>
      </FormGroup>
    </>
  );
};

export const OptionAssessmentSelection = () => {

  const [includeActive, setIncludeActive] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_ACTIVE_COVERAGES)
  const [includeExpired, setIncludeExpired] = StateApplicationParameterHook(con.OPTION_ASSESSMENT_SHOW_EXPIRED_COVERAGES)

  return (
    <>
      {/* <h3>Selección</h3> */}
      <FormGroup>
        <div className='bigParameterBox'>
          <Checkbox
            label="Activos"
            checked={includeActive}
            onChange={() => setIncludeActive(!includeActive)}
          />
          <Checkbox
            label="Vencidos"
            checked={includeExpired}
            onChange={() => setIncludeExpired(!includeExpired)}
          />
        </div>
      </FormGroup>
    </>
  );
};


